import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { UncontrolledTooltip } from 'reactstrap';
import './WrapperCard.css';

const defaultStyle = {
  header: { backgroundColor: 'white' },
  heading: { fontSize: '20px' },
  headerIcon: { cursor: 'pointer' },
  skeletonContainer: { padding: '20px' },
};

function WrapperCard({
  isLoading = false,
  contentSkeletons,
  title,
  headerStyle,
  headerIcon,
  headerIconColor = '#A8A8AA',
  showHeaderIcon = true,
  headerTooltip = 'Info',
  headerIconLink,
  enableCardBody = true,
  children,
}) {
  const renderContentSkeletons = () => {
    return (
      <>
        {Array.from({ length: contentSkeletons }).map(() => (
          <div className="skeleton skeleton-text"></div>
        ))}
      </>
    );
  };

  const renderChildren = () => {
    if (enableCardBody) {
      return (
        <div className="card-body">
          {isLoading && renderContentSkeletons()}
          <div className={isLoading ? 'd-none' : ''}>{children}</div>
        </div>
      );
    }

    return (
      <>
        {isLoading && <div className="p-3">{renderContentSkeletons()}</div>}
        <div className={isLoading ? 'd-none' : ''}>{children}</div>
      </>
    );
  };

  const tooltipTarget = `t${title.replace(/[^\w]/g, '')}`;

  return (
    <div className="card w-100">
      <div className="card-header text-left" style={headerStyle || defaultStyle.header}>
        <div className="row">
          <div className="col-md-10 pl-2">
            {isLoading ? (
              <div className="skeleton skeleton-title"></div>
            ) : (
              <h3 style={defaultStyle.heading}>{title}</h3>
            )}
          </div>
          {showHeaderIcon && !isLoading && (
            <div className="col-md-2 dflex align-content-center text-right pr-2">
              <div onClick={() =>  window.location.reload()}>
                <FontAwesomeIcon
                  icon={headerIcon || faInfoCircle}
                  color={headerIconColor}
                  id={tooltipTarget}
                  style={defaultStyle.headerIcon}
                />
              </div>
              <UncontrolledTooltip target={tooltipTarget}>{headerTooltip}</UncontrolledTooltip>
            </div>
          )}
          {isLoading && (
            <div className="col-md-2 text-right pr-2">
              <div className="skeleton skeleton-icon"></div>
            </div>
          )}
        </div>
      </div>
      {renderChildren()}
    </div>
  );
}

export default WrapperCard;
